import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api, POST, POST_JSON } from "../../ConsumeApiController";


export async function getProducts()
{
    const route = CompanyRoutes.Products.getAll;
    const response = await api.get(route);
    return response;
}


export async function getForStoreData()
{
    const route = CompanyRoutes.Products.getForStoreData
    const response = await api.get(route);
    return response;
}

export async function createProduct(
    nombre, descripcion, idUnidad, idSubCategoria, estatus, 
    imagen, has_variants, variants, precio=0,cantidad=0,
    modifier_groups=[],is_subscription,plan_id,
    is_reservable,duration_minutes
)
{
    const params = [
        {name:'nombre',value:nombre},
        {name:'descripcion',value:descripcion},
        {name:'idUnidad',value:idUnidad},
        {name:'idSubCategoria',value:idSubCategoria},
        {name:'precio',value:precio},
        {name:'cantidad',value:cantidad},
        {name:'estatus',value:estatus},
        {name:'imagen',value:imagen},
        //{name:'has_variants',value:has_variants},
        {name: 'has_variants', value: has_variants ? '1' : '0' },
        {name:'variants',value:JSON.stringify(variants)},
        {name:'modifier_groups',value:JSON.stringify(modifier_groups)},
        {name:'is_subscription',value:is_subscription?'1':'0'},
        {name:'is_reservable',value:is_reservable?'1':'0'}
    ];

    if (is_subscription == true && plan_id) {
        params.push({ name: 'plan_id', value: plan_id });
    }

    if(is_reservable === true && duration_minutes){
        params.push({name:'duration_minutes',value:duration_minutes});
    }

    const route = CompanyRoutes.Products.create;
    const response = await POST(route,params);

    return response;
}


/*
|--------------------------------------------------------------------------
| OBTENER UN PRODUCTO POR ID
|--------------------------------------------------------------------------
| EN - Fetches a single product by its ID for editing.
| ES - Obtiene un solo producto por su ID para editarlo.
*/
export async function getProductById(productId) {
    const route = `${CompanyRoutes.Products.show}/${productId}`; // Asumiendo que .show es '.../products'
    const response = await api.get(route);
    return response;
}


/*
|--------------------------------------------------------------------------
| ACTUALIZAR UN PRODUCTO
|--------------------------------------------------------------------------
| EN - Sends the updated product data, including variants, using FormData.
| ES - Envía los datos actualizados del producto, incluyendo variantes, usando FormData.
*/
export async function updateProduct(
    productId, // <-- ID del producto a actualizar
    nombre,
    descripcion,
    idUnidad,
    idSubCategoria,
    estatus,
    imagen, // El nuevo archivo de imagen (o null si no se cambió)
    has_variants,
    variants,
    precio = 0,
    cantidad = 0,
    modifier_groups = [],
    is_subscription,
    plan_id,
    is_reservable, duration_minutes
) {
    const params = [
        { name: 'nombre', value: nombre },
        { name: 'descripcion', value: descripcion },
        { name: 'idUnidad', value: idUnidad },
        { name: 'idSubCategoria', value: idSubCategoria },
        { name: 'estatus', value: estatus },
        { name: 'has_variants', value: has_variants ? '1' : '0' },
        { name: 'modifier_groups', value: JSON.stringify(modifier_groups) },
        { name: 'is_subscription', value:is_subscription ? '1' : '0' },
        { name: 'is_reservable', value: is_reservable ? '1' : '0' }
    ];

    // Solo añade la imagen si el usuario seleccionó una nueva
    if (imagen) {
        params.push({ name: 'imagen', value: imagen });
    }

    if (has_variants) {
        params.push({ name: 'variants', value: JSON.stringify(variants) });
    } else {
        params.push({ name: 'precio', value: precio });
        params.push({ name: 'cantidad', value: cantidad });
    }
    
    if (is_subscription == true && plan_id) {
        params.push({ name: 'plan_id', value: plan_id });
    }

    if (is_reservable == true && duration_minutes) {
        params.push({ name: 'duration_minutes', value: duration_minutes });
    }

    // Llama a tu función POST, pero a la ruta de actualización
    const route = `${CompanyRoutes.Products.update}/${productId}`; // Asumiendo que .update es '.../products'
    let response = await POST(route, params);
    return response;
}




export async function changeProductStatus(idProducto)
{
    const route = CompanyRoutes.Products.ChangeStatus;
    const response = await api.post(route,{idProducto});
    return response;
}

